import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
 
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import { LoginContex } from "../../context/loginContext/LoginContext";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import SalesForm from "../SalesForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Grid, _ } from "gridjs-react";
import DataTable from "react-data-table-component";
import Select from "react-select";

const TransferIptv = () => {
 
  const [isEditing, setEditing] = useState(false);
  const [newSerial, setnewSerial] = useState("");
  const [newMac, setnewMac] = useState("");
  
  

  const [subscriptionId, setSubscriptionId] = useState("");
  const [OldMacAddress, setOldMacAddress] = useState("");
  const [OldSerialNumber, setOldSerialNumber] = useState("");
  const [NewMacAddress, setNewMacAddress] = useState("");
  const [newSerialNumber, setNewSerialNumber] = useState("");
  

  const [customerInfo, setCustomerInfo] = useState();

  const {
   
    fetchMacAddressAndSerialNumber, macAddressAndSerialNumberData,transferIPTV
  } = useContext(LoginContex);
  const [modal_list, setmodal_list] = useState(false);
  const tog_list = () => {
    setmodal_list(!modal_list);
    clear();
  };
  
 

  const showToastMessage = (message) => {
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };


  const [modal_delete, setmodal_delete] = useState(false);
  const tog_delete = () => {
    setmodal_delete(!modal_delete);
  };
  
 

  const clear = () => {
    // setSunsc("");
    setSubscriptionId("");
    setNewMacAddress("");
    setNewSerialNumber("");
    setOldSerialNumber("");
    setOldMacAddress("");
    // setMessage("");
  };
  document.title = "TRANSFER IP-TV";

  const handlersubmit = (e) => {
    e.preventDefault();

    const data = {
      subscriptionId:subscriptionId,
      serialNumber:newSerial,
      macAddress:newMac
    }
    //console.log("======================",data,"================")
    transferIPTV(data)
  };
  
  const handleChecking = () => {
    fetchMacAddressAndSerialNumber(subscriptionId)
    
    setNewMacAddress(macAddressAndSerialNumberData[0]?.macAddress)
    setNewSerialNumber(macAddressAndSerialNumberData[0]?.serialNumber)
 
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="TRANSFER IP-TV" pageTitle="Billing" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <Row className="g-4 mb-3">
                    <Col className="col-sm-auto">
                      <div>
                        <div>
                          <ToastContainer />
                          <h4 className="card-title mb-0">TRANSFER IPTV</h4>
                        </div>
                      </div>
                    </Col>
                    <Col className="col-sm">
                      <div className="d-flex justify-content-sm-end">
                        <div>
                          <Button
                            color="success"
                            className="add-btn me-1"
                            onClick={() => tog_list()}
                            id="create-btn"
                          >
                            TRANSFER
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>

              
              </Card>
            </Col>
          </Row>

          {/* end of container */}
        </Container>
      </div>

      {/* Add Modal */}
      {/* Store Registration From */}
      <Modal
        isOpen={modal_list}
        toggle={() => {
          tog_list();
        }}
        centered
        size="lg"
      >
       

        <div className="bg-light p-3 modal-header">
          <h5 className="modal-title">TRANSFER IP-TV</h5>

          <Button
            type="button"
            onClick={() => {
              setmodal_list(false);
            }}
            className="btn-close"
            aria-label="Close"
          ></Button>
        </div>

        <form onSubmit={handlersubmit}>
          <ModalBody>
           
          
            <Row style={{ marginTop: "2%" }}>
              <Col md={3}>
                <label className="form-label">Subscription ID</label>{" "}
                <span className="text-danger">*</span>
                <input
                  type="Number"
                  id="referenceno-field"
                  className="form-control"
                  placeholder="Enter The subscription ID"
                  required
                  onChange={(e) => setSubscriptionId(e.target.value)}
                  value={subscriptionId}
                  // onChange={(e) => setReferenceNo(e.target.value)}
                />
              </Col>

              <Col md={3}>
                <div className="mb-3">
                  <label htmlFor="macAddress-field" className="form-label">
                    Old Mac Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="macAddress-field"
                    className="form-control"
                    placeholder="Old MacAddress"
                    required
                    disabled
                    onChange={(e) => setOldMacAddress(e.target.value, e.target)}
                    value={subscriptionId?macAddressAndSerialNumberData[0]?.macAddress:''}
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className="mb-3">
                  <label>Old Serial Number</label>

                  <input
                    type="text"
                    id="oldSerialNumber-field"
                    className="form-control"
                    placeholder="Old Serial Number"
                    required
                
                    disabled
                    onChange={(e) => setOldSerialNumber(e.target.value, e.target)}
                    value={subscriptionId?macAddressAndSerialNumberData[0]?.serialNumber:''}
                    // onChange={(e) => setCustPhone(e.target.value)}
                    // value={custPhone}
                    // onChange={(e) => setReferenceNo(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={3}>
              <div className="mb-3">
              <label>.</label>
              <Button
                    type="button"
                    className="btn btn-warning"
                    style={{ width: "100%" }}
                    onClick={()=> handleChecking()}
                  >
                    Fetch subscription ID
                  </Button>
                  </div>
              </Col>

            </Row>

            <Row>
            <Col md={6}>
                <div className="mb-3">
                  <label htmlFor="macAddress-field" className="form-label">
                    New Mac Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="macAddress-field"
                    className="form-control"
                    placeholder="New Mac Address"
                    required
                    onChange={(e) => setnewMac(e.target.value)}
                    value={newMac}
                  />
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <label>New Serial Number</label>

                  <input
                    type="text"
                    id="newSerialNumber-field"
                    className="form-control"
                    placeholder="New Serial Number"
                    required
                    onChange={(e) => setnewSerial(e.target.value)}
                    // value={newSerial}
                 
                    // onChange={(e) => setCustPhone(e.target.value)}
                    // value={custPhone}
                    // onChange={(e) => setReferenceNo(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <ToastContainer />
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
              {/* <button type="submit" className="btn btn-success" id="add-btn">
                                Assign
                            </button> */}
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handlersubmit}
              >
                {isEditing ? "Update" : "Save"}
              </button>
            </div>
          </ModalFooter>
        </form>

        {/* =================================== */}
      </Modal>

      {/* Add Modal */}
      {/* Purchase Customer From */}


      {/* Remove Modal */}
    
    </React.Fragment>
  );
};

export default TransferIptv;
